import { Truck, Plane, Ship, Package, CheckCircle, Clock, Award, Users } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { lazy, Suspense } from 'react'
import SEO from '../components/SEO'
import { serviceSEOData } from '../utils/serviceSEO'

// ✅ Import images to ensure they work in production
import hero1 from '../assets/Services/logistics/hero-1.jpg'
import hero2 from '../assets/Services/logistics/hero-2.jpg'
import hero3 from '../assets/Services/logistics/hero-3.jpg'
import freightImg from '../assets/Services/logistics/freight.jpg'
import warehousingImg from '../assets/Services/logistics/warehousing.jpg'
import supplyChainImg from '../assets/Services/logistics/supply-chain.jpg'
import customsImg from '../assets/Services/logistics/customs.jpg'

const ServicePageLayout = lazy(() => import('../components/ServicePageLayout'))

const Logistics = () => {
  const { t } = useTranslation()
  
  const service = {
    heroSlides: [
      {
        image: hero1, // ✅ Use imported variable
        title: t('logistics.heroSlides.0.title'),
        subtitle: t('logistics.heroSlides.0.subtitle'),
        description: t('logistics.heroSlides.0.description')
      },
      {
        image: hero2,
        title: t('logistics.heroSlides.1.title'),
        subtitle: t('logistics.heroSlides.1.subtitle'),
        description: t('logistics.heroSlides.1.description')
      },
      {
        image: hero3,
        title: t('logistics.heroSlides.2.title'),
        subtitle: t('logistics.heroSlides.2.subtitle'),
        description: t('logistics.heroSlides.2.description')
      }
    ],
    introText: t('logistics.introText'),
    stats: [
      { value: "100%", label: t('logistics.stats.coverage') },
      { value: "24/7", label: t('logistics.stats.support') },
      { value: t('logistics.stats.global'), label: t('logistics.stats.network') },
      { value: t('logistics.stats.secure'), label: t('logistics.stats.handling') }
    ],
    capabilities: [
      t('logistics.capabilities.0'),
      t('logistics.capabilities.1'),
      t('logistics.capabilities.2'),
      t('logistics.capabilities.3'),
      t('logistics.capabilities.4'),
      t('logistics.capabilities.5'),
      t('logistics.capabilities.6'),
      t('logistics.capabilities.7')
    ],
    services: [
      {
        icon: Truck,
        title: t('logistics.services.transportation.title'),
        description: t('logistics.services.transportation.description'),
        image: freightImg // ✅ Use imported variable
      },
      {
        icon: Package,
        title: t('logistics.services.warehousing.title'),
        description: t('logistics.services.warehousing.description'),
        image: warehousingImg
      },
      {
        icon: CheckCircle,
        title: t('logistics.services.vehicleEquipment.title'),
        description: t('logistics.services.vehicleEquipment.description'),
        image: supplyChainImg
      },
      {
        icon: Ship,
        title: t('logistics.services.specializedLogistics.title'),
        description: t('logistics.services.specializedLogistics.description'),
        image: customsImg
      }
    ],
    workflow: [
      {
        step: "01",
        title: t('logistics.workflow.0.title'),
        description: t('logistics.workflow.0.description')
      },
      {
        step: "02",
        title: t('logistics.workflow.1.title'),
        description: t('logistics.workflow.1.description')
      },
      {
        step: "03",
        title: t('logistics.workflow.2.title'),
        description: t('logistics.workflow.2.description')
      },
      {
        step: "04",
        title: t('logistics.workflow.3.title'),
        description: t('logistics.workflow.3.description')
      }
    ]
  }

  return (
    <>
      <SEO {...serviceSEOData['logistics']} url="/services/logistics" />
      <Suspense fallback={<div className="min-h-screen flex items-center justify-center">Loading...</div>}>
        <ServicePageLayout
        title={service.heroSlides[0].title}
        subtitle={service.heroSlides[0].subtitle}
        description={service.heroSlides[0].description}
        backgroundImages={service.heroSlides.map(slide => slide.image)}
        heroSlides={service.heroSlides}
        introText={service.introText}
        capabilities={service.capabilities}
        services={service.services}
        stats={service.stats}
        workflow={service.workflow}
        />
      </Suspense>
    </>
  )
}

export default Logistics